// calcPathCenterCoords is now pre-computed in Map.php

// External (area) locations come from the AI's Google Places lookup, where a
// result can lack geometry — leaving lat/lng null or undefined. Feeding those
// into google.maps.LatLng yields NaN, which corrupts fitBounds/setZoom and
// blanks the map (throws "uint32"). Only keep locations with finite coords.
export function isValidExternalLocation(loc) {
  if (!loc) return false;
  const { lat, lng } = loc;
  // Reject null/undefined/empty before Number() — Number(null) and Number('')
  // both coerce to 0, which would slip a bogus (0,0) location through.
  if (lat == null || lng == null || lat === '' || lng === '') return false;
  return Number.isFinite(Number(lat)) && Number.isFinite(Number(lng));
}
